{
  "name": "angular-starter",
  "version": "1.0.259",
  "scripts": {
    "ng": "ng",
    "dev": "ng serve --port 4200",
    "start": "ng serve --port 4200",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "coverage": "ng test --no-watch --code-coverage",
    "lint": "ng lint",
    "serve": "node dist/angular-starter/server/server.mjs",
    "local-build": "ng build --c=development && node dist/angular-starter/server/server.mjs",
    "qa-build": "ng build --c=qa && node dist/angular-starter/server/server.mjs",
    "uat-build": "ng build --c=uat && node dist/angular-starter/server/server.mjs",
    "prod-build": "ng build --c=production && node dist/angular-starter/server/server.mjs",
    "clear-cache": "node clear-cache.mjs"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "19.0.5",
    "@angular/cdk": "^19.1.0",
    "@angular/common": "19.0.5",
    "@angular/compiler": "19.0.5",
    "@angular/core": "19.0.5",
    "@angular/forms": "19.0.5",
    "@angular/material": "^19.1.0",
    "@angular/platform-browser": "19.0.5",
    "@angular/platform-browser-dynamic": "19.0.5",
    "@angular/platform-server": "19.0.5",
    "@angular/router": "19.0.5",
    "@angular/ssr": "19.0.6",
    "@fortawesome/fontawesome-free": "6.7.2",
    "@rollup/rollup-linux-x64-gnu": "^4.64.5",
    "bootstrap": "5.3.3",
    "express": "4.21.2",
    "ngx-bootstrap": "^19.0.2",
    "ngx-infinite-scroll": "^19.0.0",
    "rxjs": "7.8.1",
    "sweetalert2": "^11.17.2",
    "tslib": "2.8.1",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "19.0.6",
    "@angular/cli": "19.0.6",
    "@angular/compiler-cli": "19.0.5",
    "@types/express": "5.0.0",
    "@types/jasmine": "5.1.5",
    "@types/node": "22.10.3",
    "angular-eslint": "19.0.2",
    "autoprefixer": "^10.4.21",
    "eslint": "9.17.0",
    "jasmine-core": "5.5.0",
    "karma": "6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "2.2.1",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.1.0",
    "postcss": "^8.5.3",
    "tailwindcss": "^3.4.17",
    "typescript": "5.6.3",
    "typescript-eslint": "8.19.0"
  }
}
